import { render, staticRenderFns } from "./processDetail.vue?vue&type=template&id=e939187e&scoped=true"
import script from "./processDetail.vue?vue&type=script&lang=js"
export * from "./processDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e939187e",
  null
  
)

export default component.exports